module.exports = __webpack_public_path__ + "/images/cover-elige-int.fb8235e.svg";